/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains title of current page/template
 */
export const titleContextKey = "title";
